export const CLIENT_FIELD_NAME = 'client';

export const FARM_FIELD_NAME = 'farm';

export const FIELD_NAME_FIELD_NAME = 'field';

export const SELECT_FIELD_EMPTY_LABEL = '';

export const TEST_ID = 'selectClientFarmFieldField';
